// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import {
   MonthlyHeader,
   CoreProductRow,
   PerformanceProductRow,
   TimeAttendanceProductRow,
   TimeClocksProductRow,
   TimeClocksTable,
   BenefitsAdministrationProductRow,
   PayrollProductRow,
   PayrollStatesProductRow,
   MultiEINInputRow,
   PayrollFirstPayDateRow,
   MonthlyTotalRow,
   MultiEINTable,
   USEmployeeRow,
   ATSOnlyRow,
   AdditionalJobPostingsRow,
   MonthlyTaxRow,
   EINIntegrationProductRow,
   TimeClocksShippingTable,
   DynamicMonthlyProductRows,
} from '../rows/monthly'
import { HorizontalRule, QuoteAccordion } from '../ui-helper-elements'
import { IsForeignCurrencyQuote } from '../../common/helpers.mjs'
// JS Imports
// Asset Imports

export default function MonthlySection() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['TimeClocks']

   if (state.user_view == 'External') {
      if (!IsForeignCurrencyQuote(state.pricebookId)) {
         return (
            <QuoteAccordion
               accordionName='Monthly'
               accordionBodyId='monthlyAccordion'
               collapse='false'
            >
               <MonthlyHeader />
               <CoreProductRow />
               <PerformanceProductRow />
               <TimeAttendanceProductRow />
               <TimeClocksProductRow />
               <AdditionalJobPostingsRow />
               <USEmployeeRow />
               <ATSOnlyRow />
               <BenefitsAdministrationProductRow />
               <MonthlyTaxRow />
               <DynamicMonthlyProductRows />
               <PayrollProductRow />
               <PayrollStatesProductRow />
               <EINIntegrationProductRow />
               <MultiEINInputRow />
               <PayrollFirstPayDateRow />
               <MonthlyTotalRow />
               <MultiEINTable />
               <TimeClocksTable />
            </QuoteAccordion>
         )
      } else if (IsForeignCurrencyQuote(state.pricebookId)) {
         return (
            <div>
               <QuoteAccordion
                  accordionName='Monthly'
                  accordionBodyId='monthlyAccordion'
                  collapse='false'
               >
                  <MonthlyHeader />
                  <CoreProductRow />
                  <PerformanceProductRow />
                  <TimeAttendanceProductRow />
                  <TimeClocksProductRow />
                  <AdditionalJobPostingsRow />
                  <USEmployeeRow />
                  <ATSOnlyRow />
                  <BenefitsAdministrationProductRow />
                  <MonthlyTaxRow />
                  <DynamicMonthlyProductRows />
                  <MonthlyTotalRow />
                  <TimeClocksTable />
               </QuoteAccordion>
               {(state.hasUSEmployees ||
                  state.productPayrollTotalEECount > 0) && (
                  <QuoteAccordion
                     accordionName='Payroll'
                     accordionBodyId='payrollAccordion'
                     collapse='true'
                  >
                     <MonthlyHeader />
                     <PayrollProductRow />
                     <PayrollStatesProductRow />
                     <EINIntegrationProductRow />
                     <MultiEINInputRow />
                     <PayrollFirstPayDateRow />
                     <MultiEINTable />
                  </QuoteAccordion>
               )}
            </div>
         )
      }
   } else {
      if (!IsForeignCurrencyQuote(state.pricebookId)) {
         return (
            <div>
               <HorizontalRule />
               <MonthlyHeader />
               <CoreProductRow />
               <PerformanceProductRow />
               <TimeAttendanceProductRow />
               <TimeClocksProductRow />
               <AdditionalJobPostingsRow />
               <USEmployeeRow />
               <ATSOnlyRow />
               <BenefitsAdministrationProductRow />
               <MonthlyTaxRow />
               <DynamicMonthlyProductRows />
               <PayrollProductRow />
               <PayrollStatesProductRow />
               <EINIntegrationProductRow />
               <MultiEINInputRow />
               <PayrollFirstPayDateRow />
               <MonthlyTotalRow />
               <MultiEINTable />
               <TimeClocksTable />
               <TimeClocksShippingTable />
            </div>
         )
      } else if (IsForeignCurrencyQuote(state.pricebookId)) {
         return (
            <div>
               <HorizontalRule />
               <MonthlyHeader />
               <CoreProductRow />
               <PerformanceProductRow />
               <TimeAttendanceProductRow />
               <TimeClocksProductRow />
               <AdditionalJobPostingsRow />
               <USEmployeeRow />
               <ATSOnlyRow />
               <BenefitsAdministrationProductRow />
               <MonthlyTaxRow />
               <DynamicMonthlyProductRows />
               <MonthlyTotalRow />
               <TimeClocksTable />
               <TimeClocksShippingTable />
               <PayrollProductRow />
               <PayrollStatesProductRow />
               <EINIntegrationProductRow />
               <MultiEINInputRow />
               <PayrollFirstPayDateRow />
               <MultiEINTable />
            </div>
         )
      }
   }
   return null
}
